import {IconButton, Tooltip, IconButtonProps} from '@mui/material'
import React from 'react'

interface IconButtonWithTooltipProps extends IconButtonProps {
  tooltipContent: React.ReactNode
  icon: React.ReactNode
  'data-test-id'?: string
}

export function IconButtonWithTooltip({
  tooltipContent,
  icon,
  ...props
}: IconButtonWithTooltipProps) {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: (theme) => theme.spacing(50)
          }
        }
      }}
      title={tooltipContent}
    >
      <IconButton {...props}>{icon}</IconButton>
    </Tooltip>
  )
}
